// Glocke der Topbar (UX §2.5) mit den Benachrichtigungen aus dem Kern.
import { NotificationBell } from '@bar/ui/basis';
import type { PlatformKey } from '@web/registry/types';
import { useShellNotifications } from './notifications';

export function ShellBell({ platform }: { platform: PlatformKey }) {
  const n = useShellNotifications(platform);
  // Die Seite „Notifications“ gehört der People-App; aus Admin/AI per voller Navigation.
  const external = platform !== 'people';
  return (
    <NotificationBell
      items={n.items}
      loading={n.loading}
      error={n.error}
      onRetry={n.retry}
      onOpen={(item) => {
        if (!item.read) n.markRead(item.id);
      }}
      onMarkAllRead={n.markAllRead}
      pageHref="/notifications"
      pageReload={external}
      settingsHref="/account/notifications"
      settingsReload={external}
    />
  );
}
